import React from 'react';
import PreLoginSessionCheck from './PreLoginSessionCheck.js';
import BuyOption from './BuyOption.js';
import VideoComponent from './VideoComponent.js';
import centalogo from '../../../images/icons/centalogo.png';

// ES6 class-style
class TeacherBannerBuy extends PreLoginSessionCheck {
	constructor(props) {
		super(props);
		this.productDetails = localStorage.getItem('proDetail');

		this.getBuyOptions = this.getBuyOptions.bind(this);
	}

	getProductDetails(){
		//console.log(JSON.parse(this.productDetails));
		if(this.productDetails != {} && this.productDetails != undefined){
			return JSON.parse(this.productDetails);
		}else{
			return {};
		}
	}


	componentDidMount(){
		/* var clsName=this.removeWhiteSpace(this.getProductDetails()[this.props.id].ClassName)
		this.setTitle(clsName+"_title");
		this.setMeta(clsName+"_meta");
		this.setHeading(clsName+"_heading"); */
	}

	
	getBuyOptions(){
		return (<BuyOption showContactus={this.props.showContactus}  id={this.props.id} triedFree={this.props.triedFree} purchased={this.props.purchased} showSubScripeLoginForm={this.props.showSubScripeLoginForm} productBase={this.props.productBase} simpleform={this.props.simpleform} role={"TCHR"}></BuyOption>);
	}

  render() {
  	//var classname = this.getProductDetails()[this.props.id].ClassName;
  	return(
  		<section className={this.props.classes+" tchrhead"} >
  		<div className="container"> 
		  <div>
			<h1>{this.rb("Teachers.heading")}</h1>   
			<h1>{this.rb("Teachers.centaheading")}<img src={centalogo} alt="Centa Logo"/></h1> 
		  </div>
		  <div className="tchrdiv">
		  <h2>{this.rb("Tchrcomp.subheading")} <br/>
		  {this.rb("Tchrcomp.subheading1")}</h2>
		  </div>
        {/* <VideoComponent></VideoComponent> */}
  		{/* <hr className="buyoptionline"/> */}
  		{/* {this.getBuyOptions()} */}
  		</div> 
  		</section>
  		);
  	}
  }

  export default TeacherBannerBuy;


// WEBPACK FOOTER //
// ./src/prelogin/src/components/TeacherBannerBuy.js